import { useEffect } from 'react';

import { isApplicationModeInfinity } from 'src/data/system';
import { captureMessage } from 'src/lib/sentry';
import { useTemplatesActions } from 'src/store/templates';
// @ts-expect-error - useCurrentUser is not typed yet
import { useCurrentUser } from 'src/store/user';
// @ts-expect-error - useCurrentWorkspaceId is not typed yet
import { useCurrentWorkspaceId } from 'src/store/workspace';

export const useMaintainTemplatesStoreState = () => {
  const currentUser = useCurrentUser();
  const currentWorkspaceId = useCurrentWorkspaceId();

  const templatesActions = useTemplatesActions();

  /**
   * Maintain "sub-templates" list actuality
   */
  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    // we don't need "sub-templates" in Infinity
    if (isApplicationModeInfinity()) {
      return;
    }

    const fetchData = async () => {
      try {
        await templatesActions.querySubTemplates();
      } catch (error) {
        captureMessage('Error while fetching "sub-templates"', {
          level: 'warning',
          extra: {
            error: (error as Error).toString(),
            source: 'useMaintainTemplatesStoreState',
          },
        });
      }
    };

    void fetchData();
  }, [currentUser, currentWorkspaceId, templatesActions]);
};
